<script lang="ts">
	import { signInWithGoogle } from '$lib/firebase';
	import type { User } from '$lib/models/user';
	import { createEventDispatcher } from 'svelte';
	import Google from './brands/Google.svelte';

	export let allowLink = false;
	const dispatch = createEventDispatcher<{ error: Error; user: User }>();

	function handleSocialLogin(name: string) {
		return async () => {
			try {
				switch (name) {
					case 'google': {
						const user = await signInWithGoogle({ allowLink });
						if (user) dispatch('user', user);
						break;
					}
				}
			} catch (error) {
				if (
					error &&
					typeof error === 'object' &&
					'code' in error &&
					error.code === 'auth/credential-already-in-use'
				) {
					await signInWithGoogle({ allowLink: false })
						.then((user) => {
							if (user) dispatch('user', user);
						})
						.catch((error) => {
							dispatch('error', error);
						});
				} else if (error instanceof Error) dispatch('error', error);
				else dispatch('error', new Error('An unknown error occurred'));
			}
		};
	}
</script>

<ul class="mx-auto flex w-full max-w-lg justify-center gap-4">
	<li class="flex-grow">
		<button
			on:click|preventDefault={handleSocialLogin('google')}
			class="btn btn-outline no-animation w-full hover:text-white">
			<Google />
			Continue with Google
		</button>
	</li>
	<!-- <li class="flex-grow">
		<button
			on:click|preventDefault={handleSocialLogin('facebook')}
			class="btn btn-outline no-animation w-full hover:text-white">
			<svelte:component this={Facebook} />
		</button>
	</li>
	<li class="flex-grow">
		<button
			on:click|preventDefault={handleSocialLogin('apple')}
			class="btn btn-outline no-animation w-full hover:text-white">
			<svelte:component this={Apple} />
		</button>
	</li> -->
</ul>
